/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Roster_BodyInputs */

const th_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายชื่อผู้เล่นมีการเปลี่ยนแปลง`)
};

const en_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The squad has changed.`)
};

const ja_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロースターが変わりました。`)
};

const zh_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阵容有变动。`)
};

const es_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La plantilla ha cambiado.`)
};

const pt_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O elenco mudou.`)
};

const id_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skuad berubah.`)
};

const fr_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’effectif a changé.`)
};

const tl_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagbago ang squad.`)
};

const vi_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội hình đã thay đổi.`)
};

const ko_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수단이 바뀌었습니다.`)
};

const de_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Kader hat sich geändert.`)
};

const ru_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Состав изменился.`)
};

const tr_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kadro değişti.`)
};

const it_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La rosa è cambiata.`)
};

const pl_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skład się zmienił.`)
};

const uk_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Склад змінився.`)
};

const hi_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम बदल गई।`)
};

const ar_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيّرت التشكيلة.`)
};

const ms_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skuad berubah.`)
};

const bn_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল বদলেছে।`)
};

const zh_tw2_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名單有異動。`)
};

const zh_hk2_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名單有異動。`)
};

const ur_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسکواڈ بدل گیا۔`)
};

const fa_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فهرست تیم تغییر کرد.`)
};

const sw_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kikosi kimebadilika.`)
};

const nl_push_roster_body = /** @type {(inputs: Push_Roster_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De selectie is gewijzigd.`)
};

/**
* | output |
* | --- |
* | "The squad has changed." |
*
* @param {Push_Roster_BodyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_roster_body = /** @type {((inputs?: Push_Roster_BodyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Roster_BodyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_roster_body(inputs)
	if (locale === "ja") return ja_push_roster_body(inputs)
	if (locale === "zh") return zh_push_roster_body(inputs)
	if (locale === "es") return es_push_roster_body(inputs)
	if (locale === "pt") return pt_push_roster_body(inputs)
	if (locale === "id") return id_push_roster_body(inputs)
	if (locale === "fr") return fr_push_roster_body(inputs)
	if (locale === "tl") return tl_push_roster_body(inputs)
	if (locale === "vi") return vi_push_roster_body(inputs)
	if (locale === "ko") return ko_push_roster_body(inputs)
	if (locale === "de") return de_push_roster_body(inputs)
	if (locale === "ru") return ru_push_roster_body(inputs)
	if (locale === "tr") return tr_push_roster_body(inputs)
	if (locale === "it") return it_push_roster_body(inputs)
	if (locale === "pl") return pl_push_roster_body(inputs)
	if (locale === "uk") return uk_push_roster_body(inputs)
	if (locale === "hi") return hi_push_roster_body(inputs)
	if (locale === "ar") return ar_push_roster_body(inputs)
	if (locale === "ms") return ms_push_roster_body(inputs)
	if (locale === "bn") return bn_push_roster_body(inputs)
	if (locale === "zh-TW") return zh_tw2_push_roster_body(inputs)
	if (locale === "zh-HK") return zh_hk2_push_roster_body(inputs)
	if (locale === "ur") return ur_push_roster_body(inputs)
	if (locale === "fa") return fa_push_roster_body(inputs)
	if (locale === "sw") return sw_push_roster_body(inputs)
	if (locale === "nl") return nl_push_roster_body(inputs)
	return en_push_roster_body(inputs)
});